import * as React from "react";
const noop = () => {
};
const useIsoLayoutEffect = typeof document !== "undefined" ? React.useLayoutEffect : noop;
export {
  useIsoLayoutEffect
};
//# sourceMappingURL=useIsoLayoutEffect.js.map
